export default "__VITE_ASSET__Za3IVBYN__"